<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/cert_list/1' }">证书管理</el-breadcrumb-item>
      <el-breadcrumb-item>选中打印</el-breadcrumb-item>
    </el-breadcrumb>
    <el-table
      class="table"
      :data="certSelects"
    >
      <el-table-column
        prop="certType"
        label="证书类型"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="stuName"
        label="学员姓名"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="stuPhone"
        label="学员手机号"
        align="center"
        width="150">
      </el-table-column>
    </el-table>
    <el-form>
      <el-form-item class="btnCon">
        <el-button
          type="primary"
          @click="_certPrintPre"
          :loading="loading"
          :disabled="disabled"
        >{{btnText}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
  import { certPrintPre } from '@/api/cert';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        certSelects: [],
        btnText: '预打印',
        loading: false,
        disabled: false
      };
    },
    created() {
      this.certSelects = this.$route.params.certSelects;
    },
    methods: {
      _certPrintPre() {
        let certIds = [];
        this.certSelects.forEach((item) => {
          certIds.push(item.id);
        });
        this.loading = true;
        certPrintPre(this.user.userId, certIds).then((res) => {
          this.loading = false;
          if (res.rspCode === 0) {
            this.disabled = true;
            this.btnText = '已预打印';
          } else {
            this.disabled = false;
            this.$message.error(res.rspDesc);
          }
        }).catch(() => {
          this.$message.error('系统异常，请重试！');
          this.loading = false;
        });
      }
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    .title
      margin-bottom: 20px;
    .btnCon
      margin-top: 20px;
      width: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
</style>